<template>
    <div class="module">
        <header class="module__header--with-disclaimer">
            <a
                class="back-btn"
                @click="goBack('admin-frequency-sets')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">Create {{ frequencySetType.label }} Frequency Set</h1>
            <p
                v-if="frequencySetType.type === frequencySetTypes.X_SERIES.type"
                class="disclaimer"
            >
                <a
                    :href="knowledgeBaseUrl"
                    target="_blank"
                >
                    View knowledge base article about creating frequency sets
                </a>
            </p>
        </header>

        <section class="module__body">
            <create-next-gen-frequency-set
                v-if="frequencySetType.type === frequencySetTypes.NEXT_GEN.type"
                @frequency-set-created="frequencySetCreated"
            />
            <create-frequency-set
                v-else
                @frequency-set-created="frequencySetCreated"
            />

            <div class="form-help">Frequency Sets cannot be edited after they’re created.</div>
        </section>
    </div>
</template>

<script>
import CreateFrequencySet from '@/components/CreateFrequencySet.vue'
import CreateNextGenFrequencySet from '@/components/CreateNextGenFrequencySet.vue'
import hasBackButton from '@/mixins/hasBackButton'
import knowledgeBase from '@/constants/knowledge-base'
import frequencySetTypes, { byValue } from '@/constants/frequency-set-types.js'
import featureFlags from '@/constants/feature-flags.js'

export default {
    components: {
        CreateFrequencySet,
        CreateNextGenFrequencySet,
    },

    mixins: [hasBackButton],

    data() {
        return {
            knowledgeBaseUrl: knowledgeBase.FREQUENCY_SETS,
            frequencySetTypes,
        }
    },

    computed: {
        frequencySetType() {
            if (this.$store.getters.hasFeatureFlag(featureFlags.NEXTGEN_FREQUENCY_SETS_ENABLED)) {
                return byValue(this.$route.query.type ?? frequencySetTypes.X_SERIES.type)
            }

            return frequencySetTypes.X_SERIES
        },
    },

    methods: {
        frequencySetCreated() {
            this.$router.push(`/${this.organizationSlug}/frequency-sets`)
        },
    },
}
</script>
<style scoped lang="scss">
.module__body {
    display: flex;

    form {
        max-width: 360px;
    }
}
</style>
